/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import {
  Grid,
  TextField,
  Box,
  Link,
  Button,
  Dialog,
  Slide,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Login from "./Login";
import RegisterForm from "./RegisterForm";
import RegisterConfirm from "./RegisterConfirm";
import axios from 'axios';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function RegisterMain(props) {

  const {goNextPage, goPreviousPage} = props;
  axios.defaults.withCredentials = true; // 세션유지

  return (
    <Grid
      className="headercontainer"
      container
      height="100vh"
      direction="column"
      justifyContent="center"
      alignItems="space-between"
      css={css `max-width: 350px; margin:0 auto`}
    >
      <Grid
        className="formcontainer"
        container
        direction="column"
        justifyContent="space-around"
        flex="1"
        width="100%"
      >
        <Grid
          className="logo"
          style={{
            textAlign: "center",
          }}
        >
          <img
            className="logoimg"
            src="/img/docircuit_logo.png"
            css={css`
              width: 80%;
              max-width: 200px;
            `}
          />
          <div
            className="bold"
            css={css`
              font-size: 16px;
            `}
          >
            Heart Rate
          </div>
        </Grid>

        <Grid
          className="regbutton"
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Box
            style={{
              marginBottom: "5px",
            }}
          >
            회원가입
          </Box>
          <Button
            variant="contained"
            style={{
              width: "95%",
              background: "#0092a2",
            }}
            onClick={goNextPage}
          >
            핸드폰으로 시작
          </Button>         
        </Grid>
        
      </Grid>
    </Grid>
  );
}

export default RegisterMain;
